module.exports = __webpack_public_path__ + "img/bg-img-0.4836dcbd.png";